import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { BASE_URL } from "../config";
import Loader from "../dist/Loader";
import { getAuthHeaders } from "../services/useAuth";

export default function POBTable() {
  const location = useLocation();

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const query = new URLSearchParams(location.search);
  const employeeId = query.get("emp_code");
  const startDate = query.get("from_date");
  const endDate = query.get("to_date");
  const stateId = query.get("state_id");

  const employeeName = query.get("emp_name") || "Employee";

  useEffect(() => {
    if (!employeeId || !startDate || !endDate) return;

    const fetchPOBData = async () => {
      setLoading(true);
      setError("");

      try {
        const res = await axios.get(
          `${BASE_URL}/api/combined-retailers/pob-details-doctor-chemist`,
          {
            headers: getAuthHeaders(),
            params: {
              employee_id: employeeId,
              start_date: startDate,
              end_date: endDate,
              state_id: stateId,
            },
          },
        );

        console.log("POB API RESPONSE:", res.data);

        setData(Array.isArray(res.data) ? res.data : []);
      } catch (err) {
        console.error(err);
        setError("Failed to load POB data");
      } finally {
        setLoading(false);
      }
    };

    fetchPOBData();
  }, [employeeId, startDate, endDate, stateId]);

  if (loading) {
  return <Loader onCancel={() => setLoading(false)} />;
}
  if (error) {
    return (
      <div className="text-center text-red-600 font-semibold">{error}</div>
    );
  }
const totalPOB = data.reduce((sum, row) => {
  return sum + Number(row.pob || 0);
}, 0);
  return (
    <div className="w-full overflow-x-auto bg-white p-6">
      <h1 className="text-center text-xl font-bold mb-4">
        POB ({employeeName}) – Productive Calls
      </h1>

      <div className="overflow-x-auto border border-gray-300">
        <table className="unlock-dcr-leave-table text-sm w-full">
          <thead className="bg-blue-600 text-white">
            <tr>
              {[
                "S.No",
                "Type",
                "Code",
                "Retailer / Doctor",
                "Working Date",
                "State",
                "City",
                "Area",
                "Mobile",
                "Address",
                "POB",
              ].map((head) => (
                <th
                  key={head}
                  className="border px-3 py-2 text-xs font-semibold"
                >
                  {head}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {data.length > 0 ? (
              data.map((row, index) => (
                <tr
                  key={index}
                  className="odd:bg-white even:bg-gray-50 hover:bg-blue-50"
                >
                  <td className="border px-2 py-2 text-center">{index + 1}</td>
                  <td className="border px-2 py-2">{row.type}</td>
                  <td className="border px-2 py-2 text-center">{row.code}</td>
                  <td className="border px-2 py-2 text-blue-700 font-medium">
                    {row.retailer}
                  </td>
                  <td className="border px-2 py-2 text-center">
                    {row.working_date}
                  </td>
                  <td className="border px-2 py-2">{row.state}</td>
                  <td className="border px-2 py-2">{row.city}</td>
                  <td className="border px-2 py-2">{row.area}</td>
                  <td className="border px-2 py-2">{row.mobile}</td>
                  <td className="border px-2 py-2">{row.address || "-"}</td>
                  <td className="border px-2 py-2 text-right font-semibold">
                    {Number(row.pob || 0).toFixed(0).replace(/\.0+$/,'')}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={11} className="text-center py-6 text-gray-500">
                  No records found
                </td>
              </tr>
            )}
          </tbody>
          <tfoot className="bg-blue-600 font-bold">
          <tr>
            <td colSpan={10} className="border px-3 py-3 text-right text-white">
              Total POB
            </td>
            <td className="border px-3 py-3 text-right text-white">
              {totalPOB.toFixed(0)}
            </td>
          </tr>
        </tfoot>

        </table>
      </div>
    </div>
  );
}
